import { render, staticRenderFns } from "./SettingsSendGridTest.vue?vue&type=template&id=5a19f695"
import script from "./SettingsSendGridTest.vue?vue&type=script&lang=js"
export * from "./SettingsSendGridTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports